import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { Eraser, Check, PenTool, RotateCcw } from 'lucide-react';

const SignaturePad = ({ label, onSave, savedUrl }) => {
  const sigRef = useRef(null);
  const [hasDrawn, setHasDrawn] = useState(false);

  const clear = () => {
    if (sigRef.current) sigRef.current.clear();
    setHasDrawn(false);
  };

  const handleEnd = () => {
    if (sigRef.current && !sigRef.current.isEmpty()) {
      setHasDrawn(true);
    }
  };

  const confirm = () => {
    if (sigRef.current && !sigRef.current.isEmpty()) {
      onSave(sigRef.current.toDataURL('image/png'));
    }
  };

  const reset = () => {
    onSave(null);
    setHasDrawn(false);
  };

  return (
    <div>
      <Label className="text-sm font-bold block mb-2 text-gray-700">{label}</Label>
      {savedUrl ? (
        <div className="border-2 border-green-400 rounded-xl p-3 bg-green-50">
          <div className="flex items-center gap-2 mb-2">
            <Check className="h-4 w-4 text-green-600" />
            <span className="text-sm font-bold text-green-700">Firma Confirmada</span>
          </div>
          <img src={savedUrl} alt="Firma" className="h-24 mx-auto rounded-lg bg-white border border-green-200 p-1" />
          <Button type="button" variant="outline" size="sm" className="w-full mt-2 border-green-300 text-green-700 hover:bg-green-100" onClick={reset}>
            <RotateCcw className="mr-1 h-3.5 w-3.5" /> Cambiar Firma
          </Button>
        </div>
      ) : (
        <div className="border-2 border-gray-200 rounded-xl overflow-hidden bg-white">
          <div className="flex items-center gap-2 px-3 py-2 bg-gray-50 border-b border-gray-200">
            <PenTool className="h-4 w-4 text-gray-400" />
            <span className="text-xs text-gray-500 font-medium">Dibuja tu firma abajo</span>
          </div>
          <SignatureCanvas
            ref={sigRef}
            penColor="black"
            canvasProps={{
              className: 'w-full',
              style: { width: '100%', height: '140px', touchAction: 'none' }
            }}
            onEnd={handleEnd}
          />
          <div className="flex gap-2 p-2 bg-gray-50 border-t border-gray-200">
            <Button type="button" variant="ghost" size="sm" onClick={clear} className="text-gray-500 flex-1" disabled={!hasDrawn}>
              <Eraser className="mr-1 h-4 w-4" /> Limpiar
            </Button>
            <Button
              type="button" size="sm" onClick={confirm}
              disabled={!hasDrawn}
              className="bg-green-600 hover:bg-green-700 text-white flex-1 disabled:opacity-40"
              data-testid={`confirm-signature-${label.includes('Remitente') ? 'remitente' : 'recolector'}`}
            >
              <Check className="mr-1 h-4 w-4" /> Confirmar
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignaturePad;
